import React from "react";
import BannerWithoutImage from "./BannerWithoutImage";

const Body = ({ children, bannerLabel, type = "primary", ...rest }) => {
  return (
    <div {...rest}>
      {bannerLabel && (
        <BannerWithoutImage className="bg-oldSilver" label={bannerLabel} />
      )}
      <div
        className={`${
          type === "secondary"
            ? "w-full xl:px-50 lg:px-12 md:px-8 sm:px-4"
            : "xl:max-w-325 lg:max-w-325 md:w-full sm:w-full xl:px-0 lg:px-12 md:px-6 sm:px-5 m-auto xl:space-y-20 lg:space-y-20 md:space-y-14 sm:space-y-12"
        } xl:my-16 lg:my-16 md:my-14 sm:my-5 min-h-96`}
      >
        {children}
      </div>
    </div>
  );
};

export default React.memo(Body);
